import React, {useState} from 'react';
import PropTypes from 'prop-types';
import withIntl from '../../../lib/withIntl';
import MenuList from './MenuList';

const getStyle = ({disabled, hovered}) => {
  const normalColor = '#00B1DB';
  const hoverColor = '#00738F';
  const disabledColor = '#E0E0E0';

  if (disabled) {
    return {
      border: `1px solid ${disabledColor}`,
      backgroundColor: disabledColor,
      color: '#999999',
    };
  }

  if (hovered) {
    return {
      border: `1px solid ${hoverColor}`,
      backgroundColor: hoverColor,
      color: '#FFFFFF',
    };
  }

  return {
    border: `1px solid ${normalColor}`,
    backgroundColor: normalColor,
    color: '#FFFFFF',
  };
};

const getImageSourcePath = (disabled) => {
  if (disabled) {
    return './svg/protocol-editor/add-consolidate-tips-disabled.svg';
  }
  return './svg/protocol-editor/add-consolidate-tips.svg';
};

function ConsolidateTipsMenu({intl, disabled, onClick, tooltipMessage}) {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return (
    <MenuList.Item
      name={intl.formatMessage({id: 'protocolEditor.menuList.addConsolidateTips'})}
      imgPath={getImageSourcePath(disabled)}
      disabled={disabled}
      onClick={handleClick}
      style={getStyle({disabled, hovered})}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      tooltipMessage={tooltipMessage}
    />
  );
}

ConsolidateTipsMenu.propTypes = {
  intl: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tooltipMessage: PropTypes.string,
};

ConsolidateTipsMenu.defaultProps = {
  disabled: false,
  onClick: () => {},
  tooltipMessage: '',
};

export default withIntl(ConsolidateTipsMenu);
